import api from "../config/api";
import { getErrorMessage } from "../config/errorHelper";

// ─────────────────────────────────────────────
//  ZONE CLIENT — lecture seule
// ─────────────────────────────────────────────

/**
 * Liste les assets de l'entreprise de l'utilisateur connecté.
 * @param {{ type?, status? }} filters
 */
export const getAllAssets = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.type)   params.append("type",   filters.type);
    if (filters.status) params.append("status", filters.status);
    const query = params.toString() ? `?${params}` : "";
    const res = await api.get(`/assets/all${query}`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/** Détail d'un asset par ID. */
export const getAssetById = async (id) => {
  try {
    const res = await api.get(`/assets/${id}`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

// ─────────────────────────────────────────────
//  ZONE ADMIN — tous les assets, toutes entreprises
// ─────────────────────────────────────────────

/**
 * Liste tous les assets — toutes entreprises confondues.
 * @param {{ companyId?, type?, status?, search? }} filters
 */
export const adminGetAssets = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.companyId) params.append("companyId", filters.companyId);
    if (filters.type)      params.append("type",      filters.type);
    if (filters.status)    params.append("status",    filters.status);
    if (filters.search)    params.append("search",    filters.search);
    const query = params.toString() ? `?${params}` : "";
    const res = await api.get(`/assets/admin/all${query}`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/** Détail d'un asset — admin sans restriction. */
export const adminGetAsset = async (id) => {
  try {
    const res = await api.get(`/assets/admin/${id}`);
    return res.data;
  } catch (err) {
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Crée un asset manuellement.
 * payload : { hostname, type, status, company: { id }, ipAddress?, os?, … }
 */
export const adminCreateAsset = async (payload) => {
  try {
    const res = await api.post("/assets/admin/create", payload);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

/**
 * Modifie un asset (patch partiel).
 * payload : { hostname?, ipAddress?, os?, status?, type?, ramGb?, companyId?, … }
 */
export const adminUpdateAsset = async (id, payload) => {
  try {
    const res = await api.put(`/assets/admin/${id}`, payload);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};

/** Supprime un asset. */
export const adminDeleteAsset = async (id) => {
  try {
    const res = await api.delete(`/assets/admin/${id}`);
    if (res.data?.code === "ERROR") throw new Error(res.data.message);
    return res.data;
  } catch (err) {
    if (!(err.response || err.request)) throw err;
    throw new Error(getErrorMessage(err));
  }
};